import type { IconData } from '@stacksjs/iconify-core'

export const travelMotorcycle: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 6v3h3a3 3 0 1 0 3 3h4a3 3 0 1 0 4.12-2.784l-.36-2.647c.34.27.771.431 1.24.431V3a2 2 0 0 0-1.618.824A3.44 3.44 0 0 0 10 1H9v2h2v1a5 5 0 0 1-5 5V3H3a3 3 0 0 0-3 3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default travelMotorcycle
